<template>
  <div class="d-flex align-center">
    <v-btn @click="onOpen" :icon="icon" :hint="hint" :color="color" rounded outlined :style="btnWidth" :x-small="xs">{{ text }} </v-btn>
    <!--    :color="theme.appBar.other.color"-->
    <v-dialog v-model="isOpen" :fullscreen="!!xs" :maxWidth="xs ? '100vw' : '800px'" :close-on-content-click="false" offset-y>
      <v-card>
        <v-card-title>
          <span>{{ title }}</span>
          <v-btn class="ml-auto" icon @click="isOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="isOpen" class="pa-1">
            <!-- <div class="text-h5 text-no-wrap">Kurs / Linien {{ selectedDate }}</div> -->
            <div class="scroll-container background" style="overflow-x: auto; height: 70vh; font-size: 12px">
              <div v-for="(row, ind) in rows" :key="ind" class="d-flex flex-row no-wrap">
                <div
                  class="d-flex cell justify-center background darken-1"
                  v-ripple
                  :class="cellClass(item)"
                  v-for="(item, col) in row"
                  :key="`${row}_${col}`"
                  @click="onCellSelected(item)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from '@/mixins/common';
import IconTextBtn from '@/components/buttons/IconTextBtn.vue';
import CustomDatePicker from '@/components/pickers/CustomDatePicker.vue';
import sortFunctions from '@/sorters/sortFunctions';

export default {
  name: 'MatrixMenu',
  mixins: [common],

  props: {
    value: String, // v-model selectedDutyDate={date:...,duty:...}

    rows: Array, // list of rows, each with a list of items. Each item needs to have a property title
    color: String,
    icon: String,
    text: String,
    hint: String,
    title: String,
    btnWidth: { type: String, default: '120px' },
  },

  data() {
    return {
      selectedItem: null,
      isOpen: false,
    };
  },

  methods: {
    onOpen() {
      console.debug('open matrixMenu', this.rows);
      this.isOpen = true;

      // setTimeout required, otherwise the dialog is not opened. Reason unclear
      setTimeout(() => {
        this.isOpen = true;
      }, 300);
    },
    onCellSelected(item) {
      this.selectedItem = item;
      // setTimeout(() => {
      this.isOpen = false;
      this.$emit('onCellSelected', item);
    },
    cellClass(item) {
      let clz = ''; //duty.hasFiles ? 'with-file' : '';
      if (item === this.selectedItem) clz += ' selected';
      return clz;
    },
  },

  watch: {
    // value(newValue) {
    //   console.debug('DateDutySelection value changed', JSON.stringify(newValue, null, 2));
    //   this.selectedDate = newValue.date;
    //   this.selectedDuty = newValue.duty;
    // },

    isOpen() {
      this.filter = null;
    },
  },
};
</script>
<style scoped>
.cell {
  white-space: nowrap;
  font-size: 13px;
  padding: 10px 16px;
  border-radius: 4px;
  border: 3px solid var(--v-background);
  margin: 4px !important;
  box-sizing: border-box;
  width: 100px !important;
}

.selected {
  color: var(--v-primary-base);
  font-weight: bolder;
}
</style>
